import { gql } from '@apollo/client';

export const GET_HELP_CENTER = gql`
  query GetHelpCenter {
    helpCenter {
      id
      title
      slug
      description

      children {
        id
        title
        slug
        description
  
        children {
          id
          title
          slug
          description
    
          articles {
            id
            title
            slug
            body
      
            sectionId
            updatedAt
          }
        }
        articles {
          id
          title
          slug
          body
    
          sectionId
          updatedAt
        }
      }
      articles {
        id
        title
        slug
        body
  
        sectionId
        updatedAt
      }
    }
  }
`;

export const SUBMIT_HELP_CONTACT_FORM = gql`
  mutation SubmitHelpContactForm($subject: String!, $message: String!, $dealName: String, $dealId: String, $documentName: String, $documentId: String, $attachmentData: String, $attachmentFilename: String) {
    submitHelpContactForm(subject: $subject, message: $message, dealName: $dealName, dealId: $dealId, documentName: $documentName, documentId: $documentId, attachmentData: $attachmentData, attachmentFilename: $attachmentFilename) {
      success
    }
  }
`;

export const GET_DEALS_FOR_CONTACT = gql`
  query GetDealsForContact($teamId: ID!) {
    dealsForTeam(teamId: $teamId) {
      id
      title
    }
  }
`;

export const GET_DOCUMENTS_FOR_CONTACT = gql`
  query GetDocumentsForContact($dealId: ID!) {
    getDocumentsByDeal(dealId: $dealId) {
      id
      title
    }
  }
`;
